module.exports = __webpack_public_path__ + "img/Feature.355b7fc5.png";